import { Outlet } from 'react-router-dom';

function WhatsApp() {
  return <Outlet />;
}

export default WhatsApp;
